import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Toast } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import { removeNotification } from '@severed-links/common.redherrings-reducers/notifications'
import * as s from './Notification.scss'

const variantMap = {
    error: 'danger',
}

const variantIcons = {
    danger: 'exclamation-circle',
    info: 'info-circle',
    primary: 'info-circle',
    secondary: 'info-circle',
    success: 'check-circle',
    warning: 'exclamation-triangle',
}

const variantLabels = {
    danger: 'Something needs attention',
    info: 'Heads up',
    primary: 'Update',
    secondary: 'Update',
    success: 'Success',
    warning: 'Warning',
}

const getVariant = notification => {
    const rawVariant = notification.type || notification.messageType || notification.variant || 'info'
    return variantMap[rawVariant] || rawVariant
}

const Notification = ({ notification }) => {
    const dispatch = useDispatch()
    const swipeStart = useRef(null)

    if (!notification) return null
    const i = notification || {}
    const variant = getVariant(i)
    const icon = i.icon || variantIcons[variant] || variantIcons.info
    const title = i.headline || i.subject || variantLabels[variant] || variantLabels.info
    const className = `${s.container} ${s[variant] || s.info}`
    const autohide = i.timeout !== 0
    const dismiss = () => dispatch(removeNotification(i))

    const handlePointerDown = event => {
        if (!event.isPrimary || !['touch', 'pen'].includes(event.pointerType)) {
            swipeStart.current = null
            return
        }
        if (event.target.closest('button, a, input, textarea, select')) return

        swipeStart.current = {
            pointerId: event.pointerId,
            x: event.clientX,
            y: event.clientY,
        }
        event.currentTarget.setPointerCapture(event.pointerId)
    }

    const handlePointerUp = event => {
        const start = swipeStart.current
        if (!start || start.pointerId !== event.pointerId) return
        swipeStart.current = null

        const dx = event.clientX - start.x
        const dy = event.clientY - start.y
        // Require a deliberate swipe in the dominant direction, not a tap.
        const swipedLeft = dx <= -50 && Math.abs(dx) >= Math.abs(dy)
        const swipedUp = dy <= -50 && Math.abs(dy) >= Math.abs(dx)
        if (swipedLeft || swipedUp) dismiss()
    }

    const cancelSwipe = () => { swipeStart.current = null }

    return (
        <Toast
            className={className}
            delay={i.timeout || 4000}
            autohide={autohide}
            onClose={dismiss}
            onPointerDown={handlePointerDown}
            onPointerUp={handlePointerUp}
            onPointerCancel={cancelSwipe}
            onLostPointerCapture={cancelSwipe}>
            <Toast.Header className={s.heading}>
                <div className={s.headingIcon}><FontAwesomeIcon name={icon} /></div>
                <div className={s.headingText}>{title}</div>
            </Toast.Header>
            {i.message ? <Toast.Body className={s.toastBody}>{i.message}</Toast.Body> : null}
        </Toast>
    )
}

export default Notification
